var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlphabank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alphabank",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168,
    height: 43,
    viewBox: "0 0 168 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161409",
    "data-name": "Rectangle 161409",
    width: 150,
    height: 29,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161408",
    "data-name": "Rectangle 161408",
    width: 168,
    height: 43,
    rx: 5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(10 7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175809",
    "data-name": "Group 175809",
    transform: "translate(4 -7.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alpha-bank",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161258",
    "data-name": "Rectangle 161258",
    width: 142,
    height: 44,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Alpha_Bank_logo",
    transform: "translate(4.371 10.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4240",
    d: "M0,22.171H27.889V0H0Z",
    fill: "#0d3b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4242",
    d: "M27.507,15.322c0,5.769-4.159,8.132-10.228,8.132s-10.23-2.363-10.23-8.132S11.21,7.19,17.279,7.19s10.228,2.365,10.228,8.132",
    transform: "translate(-3.35 -4.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4244",
    d: "M10,17.047c0,4.893,3.143,6.9,8.679,6.9s8.68-2.006,8.68-6.9-3.142-6.9-8.68-6.9-8.679,2-8.679,6.9",
    transform: "translate(-4.755 -5.915)",
    fill: "#0d3b70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4246",
    d: "M15.725,13.079V15.4H12.957a9.622,9.622,0,0,0-.477,2.641h3.246v5.9a15.99,15.99,0,0,0,3.209.443V19.863l4.875,4.01a7.153,7.153,0,0,0,2.466-1.722l-4.821-4.112h5.792a10.63,10.63,0,0,0-.531-2.641H18.935V12.649a26.732,26.732,0,0,0-3.209.43",
    transform: "translate(-5.931 -7.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4264",
    d: "M134.747,19.063l1.915,2.948H132.9Zm-.577-1.45L129.349,25h1.666l1.324-1.968h4.894L138.526,25h1.738l-4.7-7.39H134.17m26.75,0L155.285,21.2V17.613h-1.594V25h1.594V22.4l1.4-.885L161.267,25h2.159l-5.641-4.18,5.012-3.21H160.92M141.464,25h1.391V18.844L149.388,25h1.646v-7.39h-1.39v5.766l-6.277-5.766h-1.9V25M125.15,18.644c1.063,0,1.627.3,1.627.861s-.157,1.145-2.073,1.145H121.49V18.644Zm.066,3.018c1.45,0,2.125.394,2.125,1.238,0,.71-.656,1.07-1.942,1.07h-3.883V21.661Zm-5.293-4.048V25h5.786c1.607,0,3.227-.654,3.227-2.115a1.985,1.985,0,0,0-1.653-1.83,1.5,1.5,0,0,0,1.1-1.552c0-.873-.8-1.892-3.057-1.892h-5.405M110.4,19.049,112.307,22h-3.752Zm-.584-1.436L104.993,25h1.666l1.325-1.977h4.893L114.169,25h1.739l-4.7-7.39h-1.4m-7.609,0v2.978H96.479V17.613H94.891V25h1.587V21.637H102.2V25h1.587v-7.39H102.2M90.188,18.644c.833,0,1.725.465,1.725,1.158,0,1.042-.538,1.393-2.125,1.393H86.9V18.644Zm-4.874-1.031V25H86.9V22.25h2.591c1.718,0,4.014-.251,4.014-2.414,0-1.641-1.652-2.222-3.069-2.222H85.314m-7.406,0V25h6.284V23.969H79.5V17.613H77.908m-6.651,1.438L73.172,22H69.413Zm-.584-1.438L65.858,25h1.66l1.331-1.971h4.893L75.035,25h1.732l-4.7-7.39h-1.4",
    transform: "translate(-31.298 -10.266)",
    fill: "#231f20"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabank);
export default __webpack_public_path__ + "static/media/alphabank.830e2dac9c2f22a419bea2ea70e6f0f2.svg";
export { ForwardRef as ReactComponent };